import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmationModal } from './ConfirmationModal/index.js';
import { i18n } from '../i18n/translate.js';
import { loadData, loadExternalData } from '../utils/ApiUtil.js';
var POLL_INTERVAL = 60000;
var TIMEOUT_WARNING_MS = 90000;
var SESSION_EXTENDING_EVENTS = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
var AutoLogout = /*#__PURE__*/function (_React$Component) {
  function AutoLogout(props) {
    var _this;
    _classCallCheck(this, AutoLogout);
    _this = _callSuper(this, AutoLogout, [props]);
    _defineProperty(_this, "checkAndUpdateSession", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee() {
      var isExpired, secondsLeft, session;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return _this.getSessionStatus();
          case 1:
            session = _context.v;
            isExpired = _this.props.useOauthInfo ? session.expires_in === 0 : !session.active;
            secondsLeft = _this.props.useOauthInfo ? session.expires_in : session.seconds_until_expiration;
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _context.v;
            isExpired = true;
            secondsLeft = 0;
          case 3:
            _this.setState({
              logout: isExpired,
              warning: !isExpired && secondsLeft * 1000 <= TIMEOUT_WARNING_MS
            });
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    })));
    _defineProperty(_this, "getSessionStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee2() {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!_this.props.useOauthInfo) {
              _context2.n = 2;
              break;
            }
            _context2.n = 1;
            return loadExternalData(_this.props.sessionUrl, _this.props.authToken, false);
          case 1:
            _t2 = _context2.v;
            _context2.n = 4;
            break;
          case 2:
            _context2.n = 3;
            return loadData(_this.props.sessionUrl, {}, false, true);
          case 3:
            _t2 = _context2.v;
          case 4:
            return _context2.a(2, _t2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "addEventListeners", function () {
      SESSION_EXTENDING_EVENTS.map(function (event) {
        window.addEventListener(event, _this.extendSession);
      });
    });
    _defineProperty(_this, "removeEventListeners", function () {
      SESSION_EXTENDING_EVENTS.map(function (event) {
        window.removeEventListener(event, _this.extendSession);
      });
    });
    _defineProperty(_this, "onWarningAction", function () {
      _this.addEventListeners();
      _this.extendSession();
    });
    _defineProperty(_this, "redirect", function () {
      if (_this.props.redirectUrl) {
        window.location.href = encodeURI(_this.props.redirectUrl);
      } else {
        window.location.reload();
      }
    });
    _defineProperty(_this, "extendSession", function () {
      if (_this.props.useOauthInfo) {
        _this.props.clearToken();
        _this.redirect();
        return;
      }
      _this.setState({
        warning: false
      }, function () {
        window.location.reload();
      });
    });
    _this.state = {
      logout: false,
      warning: false
    };
    return _this;
  }
  _inherits(AutoLogout, _React$Component);
  return _createClass(AutoLogout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.checkAndUpdateSession();
      var pollSessionStatus = setInterval(function () {
        if (!_this2.state.logout) {
          _this2.checkAndUpdateSession();
        } else {
          clearInterval(pollSessionStatus);
          window.location.reload();
        }
      }, POLL_INTERVAL);
    }
  }, {
    key: "modalTitle",
    get: function get() {
      return this.props.modalTitle || i18n.t('Your session has expired.');
    }
  }, {
    key: "modalBody",
    get: function get() {
      return this.props.modalBody || /*#__PURE__*/React.createElement("div", null, i18n.t('Unfortunately, your session has expired and we require you to login again.'));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.state.logout && /*#__PURE__*/React.createElement(ConfirmationModal, {
        title: this.modalTitle,
        onConfirm: this.redirect,
        canClose: false,
        show: true,
        confirmOnly: true
      }, this.modalBody), this.state.warning && /*#__PURE__*/React.createElement(ConfirmationModal, {
        renderAsLegacy: this.props.renderAsLegacy,
        title: i18n.t('Your session is about to expire.'),
        onConfirm: this.onWarningAction,
        canClose: false,
        show: true,
        confirmOnly: true,
        confirmButtonText: i18n.t('Yes')
      }, i18n.t('Would you like to stay logged in?')));
    }
  }]);
}(React.Component);
_defineProperty(AutoLogout, "propTypes", {
  clearToken: PropTypes.func,
  modalBody: PropTypes.node,
  modalTitle: PropTypes.string,
  redirectUrl: PropTypes.string,
  sessionUrl: PropTypes.string,
  authToken: PropTypes.string,
  useOauthInfo: PropTypes.bool,
  renderAsLegacy: PropTypes.bool
});
_defineProperty(AutoLogout, "defaultProps", {
  redirectUrl: '',
  sessionUrl: '/session_status'
});
AutoLogout.displayName = "AutoLogout";
export { AutoLogout };